import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { ForbiddenPage } from "./ForbiddenPage";

// Route guard for the WaffySSO Keycloak flow.
//   loading      → spinner
//   anonymous    → /login (which kicks off the OIDC redirect)
//   forbidden    → 403 (authenticated, but lacks staff-ops / staff-engineer-lead)
//   authenticated→ render children
export function RequireAuth({ children }: { children: ReactNode }) {
  const { state } = useAuth();
  const loc = useLocation();
  if (state.status === "loading") {
    return (
      <div className="loading">
        <div className="loading-spinner" />
        <p>Verifying session…</p>
      </div>
    );
  }
  if (state.status === "anonymous") {
    return <Navigate to="/login" replace state={{ from: loc.pathname + loc.search }} />;
  }
  if (state.status === "forbidden") {
    return <ForbiddenPage roles={state.roles} user={state.user} />;
  }
  return <>{children}</>;
}
